import {
    CHAT_MSG_ARRIVAL,
    CHAT_MSG_NEW, CHAT_MSG_NOT_ARRIVAL, CHAT_MSG_READ
} from "@/constants/chat";
import User from "@/models/user";
import {getUrlFileExt, isUrl} from "@/utils/url";

const ImageExts = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'tif',
    'tiff',
    'bmp',
    'svg',
    'webp',
]

export default class ChatMessage {

    constructor(options) {
        this._id = options?._id || 0
        this.createdAt = options?.createdAt || ""
        this.updatedAt = options?.updatedAt || ""
        this.roomId = options?.roomId || 0
        this.fromUserId = options?.fromUserId || 0
        this.statusId = options?.statusId || 0
        this.content = options?.content || ""
        this.fromUser = new User(options?.fromUser)
    }

    get isNew() {
        return this._id <= 0
    }

    get statusText() {
        switch (this.statusId) {
            case CHAT_MSG_NEW:
                return "新消息"
            case CHAT_MSG_ARRIVAL:
                return "已送达"
            case CHAT_MSG_NOT_ARRIVAL:
                return "未送达"
            case CHAT_MSG_READ:
                return "已读"
            default:
                return ""
        }
    }

    get isImageUrl() {
        if (isUrl(this.content)) {
            let ext = getUrlFileExt(this.content)
            return ext ? ImageExts.includes(ext.toLowerCase()) : false
        }
        return false
    }

    get isFileUrl() {
        if (isUrl(this.content)) {
            let ext = getUrlFileExt(this.content)
            return ext
        }
        return false
    }

    get isNormalUrl() {
        return isUrl(this.content)
    }

    toJSON() {
        return {...this}
    }
}
